export default __webpack_public_path__ + "3555fdaf8cdd28024247c5203a3e1a9c.svg";